import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
}), 'TextRotateVertical');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TextRotateVertical.js
// module id = 6724
// module chunks = 2